import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * { data: { construction_elements: ["fieldName1", "fieldName2"], sum: "100"}}
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */

export function trimSurroundValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,
) {
  const model = control.value;
  let msg : string = '';
  if (!model) {
    return null;
  }
	let wsRegex = /^\s+|\s+$/g; 
  if(wsRegex.test(model)){
    msg = "No blank spaces (Begin/End)";
  }
  // else{
  //   let result = model.replace(wsRegex, "");
  //   if(result.length > 35){
  //     result = result.slice(0,35);
  //     msg = 'Max length is 35';
  //   }
  // }
  return !msg
  ? null
  : {
    trimValidation: {
      message: msg,
    }
  }
}

